<template>
  <div>
    <div v-if="loading">
      <ResourceLoadStatus :loading="true"></ResourceLoadStatus>
    </div>

    <div
      v-else-if="isMobileScreenSize === false"
      class="uk-flex uk-flex-column uk-flex-center uk-flex-middle grid-background"
      :class="{ 'web-main-panel': true }"
    >
      <div
        class="login-panel uk-padding uk-flex uk-flex-column uk-flex-center uk-flex-middle uk-width-1-2@m uk-width-2-5@l uk-width-2-3@s uk-width-1-3@xl"
      >
        <div
          class="uk-margin uk-text-center uk-text-large uk-text-bolder uk-card uk-card-default chall-page-up-container uk-width-1-1"
        >
          <img
            class="login-icon uk-padding uk-flex"
            style="height: 100%; width: 100%; object-fit: contain"
            src="/icons/Official-OpenVetting-Logo-Light.png"
          />
          <h2 v-if="isDeclineInvitation" class="uk-text-bolder font-color" style="font-size: 1.4em">
            Regret
          </h2>
          <h2 v-else-if="showTooLate" class="uk-text-bolder font-color" style="font-size: 1.4em">
            The challenge has been met
          </h2>
          <div v-else>
            <h2 class="uk-text-bold uk-margin-remove-top font-color">Join the debate!</h2>
          </div>
        </div>
        <div
          v-if="showTooLate"
          class="uk-text-center uk-card uk-card-default chall-page-down-container uk-width-1-1"
        >
          <p class="font-color">
            Thank you for your interest in the OpenVetting debate: "{{
              challenge?.document?.title
            }}." Unfortunately that invitation has already been accepted.
          </p>
          <p class="font-color">We hope to include your thoughts in the future!</p>
          <p class="font-color">
            Click here to <a href="https://openvetting.ai/"><b>learn</b></a> more.
          </p>
          <div class="uk-flex uk-flex-around">
            <button
              class="uk-button uk-button-primary uk-button-large uk-border-rounded uk-text-capitalize"
              @click="viewTheDebate"
            >
              Watch the Debate
            </button>
            <button
              class="uk-button uk-button-primary uk-button-large uk-border-rounded uk-text-capitalize"
              @click="goToMydiscussions"
            >
              Start a New Topic
            </button>
          </div>
        </div>
        <div
          v-else
          class="uk-text-center uk-card uk-card-default chall-page-down-container uk-width-1-1"
        >
          <div v-if="!isDeclineInvitation">
            <div v-if="challenges.permissionLevel[0] === PermissionLevel.TEAM_LEAD">
              <div v-if="requestedPrivacyLevel === 'Optional'">
                <p>
                  The debate host has deferred to your choice whether this be kept confidential to
                  yourselves and respective advisors.
                </p>
                <div class="privacy-options">
                  <form-group v-for="option in privacyOptions" :key="option.value">
                    <label>
                      <input
                        class="uk-radio"
                        type="radio"
                        v-model="privacySelection"
                        :value="option.value"
                      />
                      <span class="uk-margin-small-left" v-html="option.label"></span>
                    </label>
                  </form-group>
                </div>
              </div>
              <p v-else-if="requestedPrivacyLevel === 'Private'" class="font-color">
                {{ challengeDetails?.host?.first_name }}
                {{ challengeDetails?.host?.last_name }} has asked this discussion be kept
                confidential to yourselves and respective advisors.
              </p>
              <p v-else>
                In the interest of public learning, discussions on OpenVetting are shareable via
                social media.
              </p>
            </div>
            <div v-if="challenges.permissionLevel[0] === PermissionLevel.COHORT">
              <p v-if="requestedPrivacyLevel === 'Private'">
                {{ challengeDetails?.host?.first_name }}
                {{ challengeDetails?.host?.last_name }} has asked this discussion be kept
                confidential.
              </p>
            </div>
            <div>
              <p>
                To elevate the best ideas on both sides, the discussion will be moderated using AI,
                threaded markup, and visual logic.
              </p>
              <p>Learn more at <a href="https://openvetting.ai/">https://openvetting.ai/</a>.</p>
            </div>
            <div class="uk-flex uk-flex-around">
              <LoaderButton
                class="uk-button uk-button-primary uk-button-large uk-margin-top uk-text-bold"
                :loaderStatus="acceptLoadStatus"
                @click="acceptInvitation"
              >
                {{ 'Accept' }}
              </LoaderButton>
              <LoaderButton
                class="uk-button uk-button-primary uk-button-large uk-margin-top uk-text-bold"
                :loaderStatus="declineLoadStatus"
                @click="declineInvitation"
              >
                {{ 'Decline' }}
              </LoaderButton>
            </div>
          </div>
          <div v-else class="decline-text-margin">
            <p class="uk-text-bolder uk-text-large font-color">
              We’re sorry this OpenVetting debate was not of interest.
            </p>
            <p class="uk-text-bolder uk-text-large font-color">
              We hope to include your thoughts on another topic in the future.
            </p>
            <p class="uk-text-bolder uk-text-large font-color">
              Click here to <a href="https://openvetting.ai/"><b>learn</b></a> more.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isMobileScreenSize === true">
      <MobileLandingPage
        :challenges="challenges"
        :requestedPrivacyLevel="requestedPrivacyLevel"
        :isAccept="isAccept"
        :joinDebatePage="joinDebatePage"
        :joinDebate="joinDebate"
        :loadingStatus="loadingStatus"
        :showTooLate="showTooLate"
        :acceptBtnShow="acceptBtnShow"
        @signIn="SignIn"
        @submit="acceptInvitation"
        @doDeclineClick="declineInvitation()"
        :acceptSavingStatus="acceptLoadStatus"
        :declineSavingStatus="declineLoadStatus"
        :isDecline="isDeclineInvitation"
      />
    </div>
  </div>
</template>
<script>
import LoaderButton from '@/components/display/button/LoaderButton.vue';
import PermissionLevel from '@/assets/js/enum/PermissionLevel';
import { mapGetters, mapMutations, mapState } from 'vuex';
import { xhr } from '../../xhr/endpoints';
import { errors } from '../../errors/errors';
import MobileLandingPage from '@/views/public/MobileLandingPage';
import LoadingStatus from '@/assets/js/enum/LoadingStatus';
import ResourceLoadStatus from '@/components/general/ResourceLoadStatus';

export default {
  name: 'ChallengeUrlInvitation',

  data() {
    return {
      privacySelection: 'Public',
      privacyOptions: [
        {
          label: 'Enable sharing',
          value: 'Public',
        },
        {
          label: 'Prefer confidentiality',
          value: 'Private',
        },
      ],
      challenge: null,
      isAccept: false,
      joinDebatePage: true,
      loadStatus: '',
      loading: false,
      showTooLate: false,
      joinDebate: true,
      acceptBtnShow: false,
      isDeclineInvitation: false,
      acceptLoadStatus: '',
      declineLoadStatus: '',
      observerData: [],
    };
  },
  async mounted() {
    //
    this.loading = true;

    if (this.challengeUrl === true) {
      this.acceptBtnShow = true;
      try {
        //
        // retrieve challenge data
        const response = await xhr.getChallenge(this.$route.params.challengeID);
        this.challenge = response;
        if (this.challenge.status) {
          this.showTooLate = true;
          this.acceptBtnShow = false;
        }
        //
        // setup privacy selection
        if (this.requestedPrivacyLevel !== 'Optional') {
          this.privacySelection = this.requestedPrivacyLevel;
        }
      } catch (e) {
        if (e instanceof errors.UnauthorizedError) {
          this.notAuthorized = true;
        } else if (e instanceof errors.NotFoundError) {
          this.notFound = true;
        }
      } finally {
        //
        // stop loader
        this.loading = false;
      }
    }
    this.loading = false;
  },
  components: {
    LoaderButton,
    MobileLandingPage,
    ResourceLoadStatus,
  },
  computed: {
    PermissionLevel() {
      return PermissionLevel;
    },
    ...mapState(['publicLinkData', 'challengeUrl', 'challengeDetails', 'userData']),
    ...mapGetters(['isMobileScreenSize', 'permissionLevel']),
    requestedPrivacyLevel() {
      return this.challenge ? this.challenge?.privacy?.selected : '';
    },
    challenges() {
      return this.challenge ? this.challenge : {};
    },
    publicLinkMessage() {
      return this.publicLinkData?.message
        ? this.publicLinkData?.message?.replace(/\n/g, '<br />')
        : '';
    },
  },
  props: {
    loadingStatus: String,
  },
  methods: {
    ...mapMutations([
      'setIdTokenFromStorage',
      'setAcceptDeclineStatus',
      'setAcceptDecline',
      'setChallengeUrl',
      'setObserverStatus',
    ]),
    goToMydiscussions() {
      this.$router.push('/discussions');
      this.setChallengeUrl(false);
      this.setAcceptDecline(false);
    },
    SignIn() {
      this.$emit('signIn');
    },
    async viewTheDebate() {
      this.setObserverStatus(true);
      this.setChallengeUrl(false);
      if (!Array.isArray(this.observerData)) {
        this.observerData = [];
      }
      this.observerData.push(this.challenge.document._id);
      localStorage.setItem('isObserver', JSON.stringify(this.observerData));
      this.$router.pushRoute.Debate(this.challenge.document._id);
    },
    async acceptInvitation(privacy) {
      try {
        this.acceptLoadStatus = LoadingStatus.LOADING;
        await xhr.acceptChallengeInvitation(
          this.$route.params.challengeID,
          privacy || this.privacySelection
        );
        this.acceptLoadStatus = LoadingStatus.SUCCESS;
        if (this.isMobileScreenSize) {
          this.joinDebatePage = false;
          this.isAccept = true;
          this.joinDebate = false;
          this.acceptBtnShow = false;
        } else {
          this.setChallengeUrl(false);
          this.$router.pushRoute.Debate(this.challenge.document._id);
        }
      } catch (e) {
        this.acceptLoadStatus = LoadingStatus.FAILED;
        console.log(e);
        this.showTooLate = true;
      }
    },
    declineInvitation() {
      this.declineLoadStatus = LoadingStatus.NONE;
      this.isDeclineInvitation = true;
    },
  },
};
</script>
<style lang="sass">
.web-main-panel
  margin: -40px !important
.chall-page-up-container
  border-radius: 15px 15px 0 0
  padding: 5% 0
.chall-page-down-container
  border-radius: 0 0 15px 15px
  padding: 5% 5%
.font-color
  color: #254858
.decline-text-margin
  padding: 5% 20%
</style>
